<template>
<!--  -------查询框组件------ -->
    <el-form  class="demo-form-inline Query_box" ref="formQuery" :model="queryVal"  :inline="true" size="mini" label-width="90px" >
        <el-form-item v-for="(item, index) in formInlines" :key="index" :label="item.label" :prop="item.prop" style="margin-bottom: 10px;">
            <template v-if="item.type == 'input'">
                <el-input v-model.trim="queryVal[item.prop]" class="input-w" :placeholder="item.pleas" clearable></el-input>
            </template>
            <template v-else-if="item.type == 'nums'">
                <el-input-number v-model="queryVal[item.prop]" class="input-w" :min="1" :max="100" :step="1" :precision="0"></el-input-number>
            </template>
            <template v-else-if="item.type == 'amountSegment'">
                <el-input v-model.number="queryVal[item.prop1]" style="width:160px" oninput="value=value.replace(/[^\d]/g,'')" :placeholder="item.pleas" clearable></el-input>
                &nbsp;-&nbsp;
                <el-input v-model.number="queryVal[item.prop2]" style="width:160px" oninput="value=value.replace(/[^\d]/g,'')" :placeholder="item.pleas" clearable></el-input>
            </template>
            
            <template v-else-if="item.type == 'select'">
                <el-select v-if="item.flog == 1" v-model="queryVal[item.prop]" filterable  class="input-w" :disabled="item.disable?true:false" @focus="focusBox(item.label)" clearable>
                    <el-option v-for="(optItem ,indexs) in item.opt" :key="'a'+indexs" :label="optItem.name" :value="optItem.val">
                        <span style="float: left">{{ optItem.name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ optItem.val }}</span>
                    </el-option> 
                </el-select>
                <el-select v-else-if="item.flog == 2" :placeholder="item.pleas" filterable remote reserve-keyword v-model="queryVal[item.prop]" class="input-w" :loading="queryVal[item.loading]" :remote-method="query => {remoteMethod(query,item.label,item.index)}" clearable>
                    <el-option v-for="(optItem ,indexs) in item.opt" :key="'b'+indexs" :label="optItem.name" :value="optItem.val">
                        <span style="float: left">{{ optItem.name }}</span>
                        <span v-if='optItem.value1' style="float: right; color: #8492a6; font-size: 12px">{{ optItem.value1 }}</span>
                    </el-option>  
                </el-select>
                <el-select v-else v-model="queryVal[item.prop]" filterable  clearable class="input-w" :disabled="item.disable?true:false" @focus="focusBox(item.label)">
                    <el-option v-for="(optItem ,indexs) in item.opt" :key="'c'+indexs" :label="optItem.name" :value="optItem.val"></el-option> 
                </el-select>
            </template>
            <template v-else-if="item.type == 'AmountRange'">
                <el-select v-model="queryVal[item.prop]" filterable clearable style="width:152px;" :disabled="item.disable?true:false" @focus="focusBox(item.label)">
                    <el-option v-for="(optItem ,indexs) in item.opt" :key="'d'+indexs" :label="optItem.name" :value="optItem.val" :disabled="optItem.disabled"></el-option> 
                </el-select>
                &nbsp;&nbsp;～&nbsp;&nbsp;
                <el-select v-model="queryVal[item.prop1]" filterable clearable style="width:152px;" :disabled="item.disable?true:false" @focus="focusBox(item.label)">
                    <el-option v-for="(optItem ,indexs) in item.opt1" :key="'e'+indexs" :label="optItem.name" :value="optItem.val" :disabled="optItem.disabled"></el-option> 
                </el-select>
            </template>
            <template v-else-if="item.type == 'select1'">
                <el-select v-model="queryVal[item.prop]" filterable clearable class="input-w" :disabled="item.disable?true:false" @focus="focusBox(item.label)">
                    <el-option v-for="(optItem ,indexs) in item.opt" :key="'f'+indexs" :label="optItem.name" :value="optItem.name"></el-option> 
                </el-select>
            </template>
            <template v-else-if="item.type == 'multipleSel'">
                <el-select v-model="queryVal[item.prop]" filterable multiple :multiple-limit="3" class="input-w" @focus="focusBox(item.label)">
                    <el-option v-for="(optItem ,indexs) in item.opt" :key="'g'+indexs" :label="optItem.name" :value="optItem.val"></el-option> 
                </el-select>
            </template>
            <template v-else-if="item.type == 'select2'">
                <el-select v-model="queryVal[item.prop]" filterable clearable class="input-w" >
                    <el-option v-for="optItem in item.opt" :key="'h' + optItem.id" :label="optItem.area" :value="optItem.id"></el-option> 
                </el-select>
            </template>
            <template v-else-if="item.type == 'select3'">
                <el-select v-model="queryVal[item.prop]" filterable clearable class="input-w" >
                    <el-option v-for="optItem in item.opt" :key="'i' + optItem.id" :label="optItem.area" :value="optItem.area"></el-option> 
                </el-select>
            </template>
            <template v-else-if="item.type == 'select4'">
                <el-select v-model="queryVal[item.prop]" filterable clearable class="input-w" >
                    <el-option v-for="optItem in item.opt" :key="'i' + optItem.name" :label="optItem.name" :value="optItem.name">
                        <span style="float: left">{{ optItem.name }}</span>
                        <p :style="{float: 'right', display: 'inline-block', width: '152px',height:'28px', background: optItem.name, fontSize:'12px', textAlign:'center', marginTop:'3px'}"></p>
                    </el-option> 
                </el-select>
            </template>
            <template v-else-if="item.type == 'cascader'">
                <el-cascader 
                    clearable
                    class="input-w"
                    style="display:inline-block;"
                    :options="item.opt"
                    v-model="queryVal[item.prop]"
                    :props="{value:'deptCode',label:'deptName' ,checkStrictly: true}"
                    :show-all-levels="false">
                </el-cascader>
            </template>
            <template v-else>
                <el-date-picker v-if="item.distinguish == 'time'"  class="input-w" v-model="queryVal[item.prop]"  type="daterange" range-separator="~" value-format="timestamp"></el-date-picker> 
                <el-date-picker v-else-if="item.distinguish == 'monthrange'"  class="input-w" v-model="queryVal[item.prop]"  type="monthrange" value-format="timestamp"></el-date-picker> 
                <el-date-picker v-else-if="item.distinguish == 'month'"  class="input-w" v-model="queryVal[item.prop]"  type="month" value-format="yyyy-MM"></el-date-picker>
                <el-date-picker v-else-if="item.distinguish == 'year'"  class="input-w" v-model="queryVal[item.prop]"  type="year" value-format="yyyy"></el-date-picker>   
                <el-date-picker v-else-if="item.distinguish == 'data'"  class="input-w" v-model="queryVal[item.prop]"  type="date" value-format="timestamp"></el-date-picker> 
                <el-date-picker v-else-if="item.distinguish == 'data1'"  class="input-w" v-model="queryVal[item.prop]"  type="date" value-format="yyyy-MM-dd"></el-date-picker>   
                <el-date-picker v-else class="input-w" v-model="queryVal[item.prop]" :default-time="['00:00:00', '23:59:59']" type="datetimerange" range-separator="~" value-format="timestamp"></el-date-picker>   
            </template>
        </el-form-item>
    </el-form>
</template>  
<script>
 export default {
    name: 'queryBox',
    props: {
        formInlines: {
            type: Array,
        },
        queryVal: {
            type: Object,
        },
    },
    methods:{
        clearF(){
            //清空表单
            this.$refs.formQuery.resetFields();
        },
        focusBox(type){
            this.$emit('focusBox',type);
        },
        remoteMethod(query,type,index){
            this.$emit('remoteMethod',query,type,index);
        }
    }
 }
</script>
<style>
    .Query_box .el-form-item__label{
        font-size: 13PX;
    }
</style>



// WEBPACK FOOTER //
// src/publicComponents/queryBox.vue